<template>
    <button
        class="btn"
        :type="type"
        :disabled="disabled"
        :class="{
            'btn-primary': variant === 'primary',
            'btn-secondary': variant === 'secondary',
            'btn-success': variant === 'success',
            'btn-error': variant === 'error',
            'btn-dark': variant === 'dark',
            'btn-outline-dark': variant === 'outline-dark',
            outline: variant && variant.startsWith('outline-'),
            'outline-primary': variant === 'outline-primary',
            'outline-secondary': variant === 'outline-secondary',
            'outline-success': variant === 'outline-success',
            'outline-error': variant === 'outline-error',
            'text-primary': variant === 'text-primary',
            'text-secondary': variant === 'text-secondary',
            'text-error': variant === 'text-error',
            disabled: disabled === true,
            'tiny-btn': tiny === true,
            'large-btn': large === true,
            'extended-btn': extended === true,
            'no-outline': outline === false,
            'no-wrap': noWrap,
        }"
        @click="onClick"
    >
        <slot v-if="!disabled || !disabledHint" />
        <template v-else>{{ disabledHint }}</template>
    </button>
</template>

<script>
export default {
    props: {
        variant: { type: String, default: () => '' },
        type: { type: String, default: () => '' },
        click: {
            type: Function,
            default: () => {},
        },
        disabledHint: { type: String, default: () => '' },

        disabled: Boolean,
        tiny: Boolean,
        large: Boolean,
        extended: Boolean,
        outline: Boolean,
        noWrap: Boolean,
    },
    methods: {
        onClick() {
            this.$emit('click', this.click);
        },
    },
};
</script>

<style>
.btn {
    position: relative;
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
}

.btn:hover:not(.disabled) {
    filter: brightness(97%);
}

.no-outline:focus {
    outline: none;
    box-shadow: none;
}

.outline {
    border: 1px solid var(--primary);
    color: var(--primary);
}

/* Primary colors */

/* Primary */
.btn-primary {
    background-color: var(--primary) !important;
    border-color: var(--primary) !important;
}
.btn-primary:hover:not(.disabled) {
    filter: brightness(96%);
}

.btn-primary:active .outline-primary:active .text-primary:active {
    filter: brightness(90%);
}

/* Primary Outlined */
.outline-primary {
    border-color: var(--primary) !important;
    color: var(--primary) !important;
}
.outline-primary:hover:not(.disabled) {
    background-color: var(--primary);
    color: white !important;
}
.outline-primary:active {
    border-color: var(--primary);
    outline-width: 2px;
    outline-color: var(--primary);
}

/* Primary Text */
.text-primary {
    color: var(--primary) !important;
}

/* Secondary colors */

/* Secondary */
.btn-secondary {
    background-color: var(--secondary) !important;
    border-color: var(--secondary) !important;
}
.btn-secondary:hover:not(.disabled) {
    filter: brightness(96%);
}
.btn-secondary:active,
.outline-secondary:active .text-secondary:active {
    filter: brightness(90%);
}

/*Secondary outlined*/
.outline-secondary {
    border-color: var(--secondary) !important;
    color: var(--secondary) !important;
}
.outline-secondary:hover:not(.disabled) {
    background-color: var(--secondary);
    color: white !important;
}

/* Secondary text */
.text-secondary {
    color: var(--secondary) !important;
}

/* Error */
.btn-error {
    background-color: var(--danger) !important;
    border-color: var(--danger) !important;
    color: white !important;
}

.outline-error {
    border-color: var(--danger) !important;
    color: var(--danger) !important;
}

.outline-error:hover:not(.disabled) {
    background-color: var(--danger);
    color: white !important;
}

/* Success */
.outline-success {
    border-color: var(--success) !important;
    color: var(--success) !important;
}

.outline-success:hover:not(.disabled) {
    background-color: var(--success);
    color: white !important;
}

/* Dark */
.btn-dark {
    color: white !important;
    background-color: #2c3342 !important;
    border-color: #2c3342 !important;
}
.btn-dark:hover:not(.disabled) {
    filter: brightness(115%);
}

/* Sizes */
.tiny-btn {
    padding: 2px 8px !important;
}

.large-btn {
    padding-left: 2.2rem !important;
    padding-right: 2.2rem !important;
    font-size: 22px !important;
}

.extended-btn {
    border-radius: 22px !important;
}

/* Error */
.text-error {
    color: var(--error) !important;
}

.disabled {
    cursor: default;
}

.disabled.outline {
    background-color: rgba(0, 0, 0, 0.2) !important;
    border-color: rgb(0.8, 0.8, 0.8) !important;
    color: rgb(0.8, 0.8, 0.8) !important;
}

/* Other */
.no-wrap {
    white-space: nowrap;
}

[class*='text-'].disabled {
    color: #bbb !important;
}
</style>
